export default __webpack_public_path__ + "static/media/wf_icon_path_animated_dark.aa9e64ba.svg";